import queryString from 'query-string'
import { getCookie } from 'cookies-next'
import { baseURL } from '@/api/request'
import { CURRENCY_COOKIE, LANG_COOKIE, TOKEN_COOKIE, REGION_COOKIE } from '@/utils/constants'
import { isEmpty, isObject } from './is'

// 生成导出链接
const generateExportUrl: typeof queryString.stringifyUrl = (object, ...args) => {
  const { url, query = {} } = object

  const newQuery: any = Object.assign(
    {
      lang: getCookie(LANG_COOKIE),
      currency: getCookie(CURRENCY_COOKIE),
      token: getCookie(TOKEN_COOKIE),
      region: getCookie(REGION_COOKIE)
    },
    query
  )
  let resQuery = ''
  Object.keys(newQuery)
    .filter((item) => !isEmpty(newQuery[item]))
    .map((key) => {
      const curVal = newQuery[key]
      if (Array.isArray(curVal)) {
        for (let i = 0; i < curVal.length; i++) {
          resQuery += `&${key}[]=${curVal[i]}`
        }
      } else if (isObject(curVal)) {
        resQuery += `&${key}=${queryString.stringify(curVal)}`
      } else {
        resQuery += `&${key}=${curVal}`
      }
    })
  if (resQuery.startsWith('&')) {
    resQuery = resQuery.substring(1)
  }

  return `${baseURL}${url}?${resQuery}`

  // return queryString.stringifyUrl(
  //   Object.assign(object, {
  //     url: baseURL + url,
  //     query: Object.assign(
  //       {
  //         lang: getCookie(LANG_COOKIE),
  //         currency: getCookie(CURRENCY_COOKIE),
  //         token: getCookie(TOKEN_COOKIE),
  //         region: getCookie(REGION_COOKIE)
  //       },
  //       query
  //     )
  //   }),
  //   ...args
  // )
}

// 生成导出路径
export const generateExportPath: typeof queryString.stringifyUrl = (object, ...args) => {
  const { url, query = {} } = object

  const newQuery: any = Object.assign(
    {
      lang: getCookie(LANG_COOKIE),
      currency: getCookie(CURRENCY_COOKIE),
      token: getCookie(TOKEN_COOKIE),
      region: getCookie(REGION_COOKIE)
    },
    query
  )
  let resQuery = ''
  Object.keys(newQuery)
    .filter((item) => !isEmpty(newQuery[item]))
    .map((key) => {
      const curVal = newQuery[key]
      if (Array.isArray(curVal)) {
        for (let i = 0; i < curVal.length; i++) {
          resQuery += `&${key}[]=${curVal[i]}`
        }
      } else if (isObject(curVal)) {
        resQuery += `&${key}=${queryString.stringify(curVal)}`
      } else {
        resQuery += `&${key}=${curVal}`
      }
    })
  if (resQuery.startsWith('&')) {
    resQuery = resQuery.substring(1)
  }

  return `${url}?${resQuery}`
}

export default generateExportUrl
